import { Link, NavLink, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { unreadNotificationCount } from '../../services/notificationService';

function Layout() {
  const { currentUser, logout } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    let active = true;
    async function loadUnread() {
      if (!currentUser) {
        if (unreadCount !== 0) setUnreadCount(0);
        return;
      }
      try {
        const count = await unreadNotificationCount(currentUser.uid);
        if (active && Number.isFinite(count) && count !== unreadCount) setUnreadCount(count);
      } catch (_err) {
        if (active && unreadCount !== 0) setUnreadCount(0);
      }
    }
    loadUnread();
    return () => { active = false; };
  }, [currentUser, unreadCount]);

  return (
    <div className="app-shell">
      <header className="site-header">
        <Link className="brand" to="/">
          <span className="brand-mark">CA</span>
          <span>Cyberautography</span>
        </Link>
        <nav className="site-nav" aria-label="Primary navigation">
          <NavLink to="/marketplace">Marketplace</NavLink>
          {currentUser ? (
            <>
              <NavLink to="/dashboard" end>Dashboard</NavLink>
              <NavLink to="/dashboard/site-theme">Site Theme</NavLink>
              <NavLink to="/dashboard/pages">Pages</NavLink>
              <NavLink to="/dashboard/problems">Problems</NavLink>
              <NavLink to="/dashboard/daily">Daily</NavLink>
              <NavLink to="/dashboard/content">Content</NavLink>
              <NavLink to="/dashboard/social">Social</NavLink>
              <NavLink to="/dashboard/notifications">Notifications{unreadCount ? ` (${unreadCount})` : ''}</NavLink>
              <NavLink to="/dashboard/settings">Settings</NavLink>
              <button className="nav-button" type="button" onClick={logout}>Log out</button>
            </>
          ) : (
            <NavLink to="/login">Log in</NavLink>
          )}
        </nav>
      </header>
      <main className="main-content">
        <Outlet />
      </main>
      <footer className="site-footer">
        <p>Built around the person, not the platform.</p>
      </footer>
    </div>
  );
}

export default Layout;
